import { ref, watch, inject } from "vue";
import { useStore } from "vuex";

export default function useImportCourseHolesModal(props, emit) {
  const store = useStore();

  const targetCourse = inject("targetCourse", null);

  const selectedFile = ref(null);
  const fileName = ref("");
  const isLoading = ref(false);
  const errorMessage = ref("");
  const errorMessages = ref([]);

  const resetForm = () => {
    selectedFile.value = null;
    fileName.value = "";
    errorMessage.value = "";
    errorMessages.value = [];
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
        errorMessage.value = "Please select a CSV file";
        selectedFile.value = null;
        fileName.value = "";
        return;
      }

      selectedFile.value = file;
      fileName.value = file.name;
      errorMessage.value = "";
    } else {
      selectedFile.value = null;
      fileName.value = "";
    }
  };

  const handleImport = async () => {
    if (!selectedFile.value) {
      errorMessage.value = "Please select a CSV file";
      return;
    }

    isLoading.value = true;
    errorMessages.value = [];

    try {
      await store.dispatch("holes/importHoles", {
        id: targetCourse.value.id,
        file: selectedFile.value,
      });

      await store.dispatch("holes/fetchHoles", targetCourse.value.id);

      store.dispatch("toastNotification/displayToast", {
        message: `Course holes updated successfully.`,
        type: "success",
      });

      isLoading.value = false;
      closeModal();
    } catch (error) {
      isLoading.value = false;
      console.log("log error", error?.message);
      if (Array.isArray(error?.response?.data?.message)) {
        errorMessages.value = error?.response?.data?.message;
      } else {
        errorMessage.value =
          error?.response?.data?.message ||
          "An unknown error occurred. Please try again.";
      }
    }
  };

  const closeModal = () => {
    resetForm();
    emit("update:modelValue", false);
  };

  watch(
    () => props.modelValue,
    (newVal) => {
      if (newVal === true) {
        resetForm();
      }
    }
  );

  return {
    targetCourse,
    selectedFile,
    fileName,
    isLoading,
    errorMessage,
    errorMessages,
    handleFileChange,
    handleImport,
    closeModal,
  };
}
